@if (showProviderChooser()) {
  <ninety-choose-calendar-provider-dialog
    [integrations]="providerChooserIntegrations()"
    (closed)="onProviderChooserClosed()" />
} @else if (showCalendarPicker()) {
  <ninety-select-calendar-event-dialog
    [connectionId]="activeCalendarConnectionId()!"
    [calendarService]="calendarEventsService()"
    [selectedEventId]="pickedEvent()?.id"
    [daysAhead]="10"
    rangeLabel="the next 10 days"
    subtitle="Choose from your upcoming meetings"
    (closed)="onCalendarClosed($event)" />
} @else {
  <h1 mat-dialog-title>Update Scheduled {{ data.schedule.agendaName }}</h1>
  @if (subtitle) {
    <h2 mat-dialog-subtitle>{{ subtitle }}</h2>
  }
  <mat-dialog-content>
    <form [formGroup]="form">
      <ninety-meeting-bot-calendar-section
        dataCyPrefix="update-meeting-schedule-dialog"
        [addMeetingAgentControl]="addMeetingAgentControl"
        [pickedEvent]="pickedEvent() ?? resolvedExistingEvent()"
        [existingMeetingLink]="data.schedule.meetingLink"
        (openPicker)="openEventPicker()"
        (openProviderChooser)="onOpenProviderChooser($event)" />

      <div class="date">
        <terra-form-field>
          <terra-form-label>Date</terra-form-label>

          <terra-date-input
            id="date-field"
            class="date__field"
            [min]="minDate"
            [max]="maxDate"
            required
            aria-label="date picker"
            formControlName="date" />
        </terra-form-field>
      </div>
      <div class="time">
        <terra-form-field>
          <terra-form-label>Time</terra-form-label>
          <terra-select formControlName="time" maxHeight="300" data-cy="update-schedule-time">
            @for (option of timeOptions(); track option.value) {
              <terra-option [value]="option.value" attr.data-cy="update-schedule-time-option-{{ option.value }}">
                {{ option.label }}
              </terra-option>
            }
          </terra-select>
        </terra-form-field>
      </div>

      <div class="presenter">
        <terra-form-field>
          <terra-form-label>Facilitator</terra-form-label>
          <terra-select formControlName="presenterId" maxHeight="350">
            @for (user of data.users; track user) {
              <terra-option [value]="user.value">{{ user.name }}</terra-option>
            }
          </terra-select>
        </terra-form-field>
      </div>

      <div class="scribe">
        <terra-form-field>
          <terra-form-label>Scribe</terra-form-label>
          <terra-select formControlName="scribeId" maxHeight="350" placeholder="Select scribe">
            <terra-option [value]="undefined">None</terra-option>
            @for (user of data.users; track user) {
              <terra-option [value]="user.value">{{ user.name }}</terra-option>
            }
          </terra-select>
        </terra-form-field>
      </div>

      @if (data.schedule.cadence !== Cadence.none) {
        <div class="update-options">
          <terra-radio-group aria-labelledby="What-to-update" formControlName="updateAll">
            <terra-form-label>
              Do you want to update one or all {{ data.meetingLanguage.item }} schedules?
            </terra-form-label>
            <terra-radio-button [value]="false" data-cy="update-schedule_radio-btn-one">
              Update only this {{ data.meetingLanguage.item }}
            </terra-radio-button>
            <terra-radio-button [value]="true" data-cy="update-schedule_radio-btn-all"> Update all </terra-radio-button>
          </terra-radio-group>
          @if (data.schedule.cadence === Cadence.monthly && form.get('updateAll')?.value === true) {
            <div class="monthly-cadence-options">
              <terra-form-field>
                <terra-form-label>Monthly Repeating Meeting Cadence</terra-form-label>
                <terra-select formControlName="monthlyCadenceOption" data-cy="update-schedule_monthly-cadence">
                  @for (option of monthlyCadenceOptions; track option) {
                    <terra-option
                      [value]="option.value"
                      attr.data-cy="update-schedule_monthly-cadence-option-{{ option.value }}">
                      {{ option.name }}
                    </terra-option>
                  }
                </terra-select>
              </terra-form-field>
            </div>
          }
          @if (form.get('updateAll')?.value === true) {
            <p class="update-all-note" data-cy="update-schedule-update-all-note">
              <b>Warning:</b> Updating all resets the schedule start date to the selected date.
            </p>
          }
        </div>
      }
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <ninety-button stroked mat-dialog-close class="right-space-10">Cancel</ninety-button>
    <ninety-button
      filled
      primary
      (click)="onUpdate()"
      [disabled]="!form.valid || !form.dirty"
      data-cy="update-schedule-actions_save-btn">
      <terra-icon icon="save" />
      Save
    </ninety-button>
  </mat-dialog-actions>
}
